import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl;

async function getPaymentTypes(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}v2/payment-types/list?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getCollectionTypes(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const { data: response } = await axios.get(
      `${endpoint}v2/collection-types/list?${query}`,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getGroups(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}v2/groups?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getGroupList(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}groups?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getGroup(groupId) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}v2/groups/${groupId}`, config);

    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Unable to fetch group',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function createGroup(formData) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}v2/groups`, formData, config);

    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Unable to create group',
      errors: error.response?.data?.errors || null,
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function updateGroup(groupId, formData) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    // Laravel doesn't support PUT/PATCH with multipart/form-data properly
    // So we use POST with _method field
    formData.append('_method', 'PUT');

    const { data: response } = await axios.post(
      `${endpoint}v2/groups/${groupId}`,
      formData,
      config
    );

    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Unable to update group',
      errors: error.response?.data?.errors || null,
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function deleteGroup(groupId) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.delete(`${endpoint}groups/${groupId}`, config);

    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Unable to delete group',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export {
  getCollectionTypes,
  getPaymentTypes,
  getGroups,
  getGroupList,
  getGroup,
  createGroup,
  updateGroup,
  deleteGroup,
};
